
export const endpoints = {

  authentication: {
    signIn: '/auth/authenticate',
    signOut: '/auth/sign-out',
    getUser: '/auth/user',
    /** GET + Bearer — user, tenantBranding, groupIds, permissions (Redis-backed on server) */
    sessionContext: '/auth/context',
    refreshToken: '/auth/refresh',
    sessionPolicy: '/auth/session-policy',
    activity: '/auth/activity',
    sessionRestored: '/auth/session-restored',
    verifyResetCode: '/verification/code',
  },

  /** Tenant DB users; requires X-TenantID = registry UUID from GET /tenants */
  tenantUsers: {
    list: '/tenant-users',
    get: '/tenant-users/',
    status: '/tenant-users/status',
  },

  users: {
    resetPassword: '/users/reset-password',
    signUp: '/users/register',
    newPassword: '/users/new-password',
    changePassword: '/users/password',
    update: '/users/update/',
    getUser: '/users/',
    getUsers: '/users',
    status: '/users/status',
    rotateStatus: '/users/rotate-status',
    uploadFile: '/users/{id}/photo',
    adminResetPassword: '/users/admin-reset-password',
    adminActivateAccount: '/users/admin-activate-account',
  },

  /** Multipart PUT ?id={userUuid}; updates tenant_user + central user when applicable */
  files: {
    photo: '/files/photo',
    /** Optional ?tenantId={registryUuid}; central disk only, path returned for data_source_config.tenant_photo */
    tenantLogo: '/files/tenant-logo',
  },

  
  sessions: {
    getUserSessions: '/sessions/user',
  },

  
  sessionTimeRanges: {
    create: '/clazz-timetables',
    getAll: '/clazz-timetables',
    get: '/clazz-timetables/',
    update: '/clazz-timetables',
    status: '/clazz-timetables/status',
    getAllActive: '/clazz-timetables/all/active',
    link: '/clazz-timetables/link',
    unlink: '/clazz-timetables/unlink',
    getSubjectsTeachersByClass: '/clazz-timetables/class',
    getTimetableByTeacher: '/clazz-timetables/teacher',
  },

  /** Central registry service catalog (CRUD on {@code service} table) */
  serviceCatalog: {
    base: '/service-catalog',
  },

  /** Central tenant ↔ service assignments ({@code tenant_service}) */
  tenantServiceAssignments: {
    base: '/tenant-services',
    byTenantWithServices: (tenantId) =>
      `/tenant-services/by-tenant/${tenantId}/with-services`,
  },

  /** Central access-control APIs (same host as /users when using registry + X-TenantID) */
  groups: {
    list: '/groups',
    status: '/groups/status',
    usersPermissionsReport: '/groups/users-permissions-report',
  },

  permissions: {
    list: '/permissions',
    status: '/permissions/status',
  },

  userAuditTrials: {
    list: '/user-audit-trials',
    get: '/user-audit-trials/',
  },

  dutiesWeeks: {
    create: '/duties-weeks',
    getDutiesWeeks: '/duties-weeks',
    getDutiesWeek: '/duties-weeks/',
    getAll: '/duties-weeks/all',
    getByTerm: '/duties-weeks/term/',
    getByTermWithTeachers: '/duties-weeks/term/',
    update: '/duties-weeks',
    status: '/duties-weeks/status',
    assignTeacher: '/duties-weeks/assign-teacher',
    unassignTeacher: '/duties-weeks/unassign-teacher',
    getTeachers: '/duties-weeks/',
  },
};
